import {
  FETCHING_ORG,
  FETCH_ORG_SUCCESS,
  FETCHING_PERMISSIONS,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE
} from './ManageUserConstants';
import axios from 'axios';

const fetchOrg = () => async dispatch => {
  const path = `/v1/iam/users/clients/orgs`;
  dispatch({ type: FETCHING_ORG });
  const response = await axios.get(path);
  dispatch({ type: FETCH_ORG_SUCCESS, data: response.data.data });
};

const fetchUserPermissions = () => async dispatch => {
  const path = '/v1/iam/permissions';
  dispatch({ type: FETCHING_PERMISSIONS });
  try {
    const response = await axios.get(path);
    dispatch({ type: FETCH_PERMISSIONS_SUCCESS, data: response.data.data });
  } catch (e) {
    dispatch({ type: FETCH_PERMISSIONS_FAILURE });
  }
};

const checkPermissions = requiredPermissions => (dispatch, getState) => {
  const userPermissions = getState().manageUser.userPermissions;
  if (!userPermissions.length) return false; //PATCH to fix issue on first load
  if (!requiredPermissions) return true;
  if (Array.isArray(requiredPermissions))
    return userPermissions.some(permission => requiredPermissions.includes(permission.name));
  if (typeof requiredPermissions === 'string')
    return userPermissions.filter(permission => permission.name === requiredPermissions).length > 0;
};

export {
  fetchOrg,
  fetchUserPermissions,
  checkPermissions
};



// WEBPACK FOOTER //
// ./src/redux/manageUser/ManageUserActions.js